import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

function SelectField({ id, name, label, allowMultipleValue, isRequired, options, updateFieldData, className }) {
  const [optionsData, setOptionsData] = useState(options);

  const onNameChange = (e) => {
    updateFieldData(id, { name: e.target.value });
  };

  const onLabelChange = (e) => {
    updateFieldData(id, { label: e.target.value });
  };

  const onIsRequiredChange = (e) => {
    updateFieldData(id, { isRequired: e.target.checked });
  };

  const onAllowMultipleValueChange = (e) => {
    updateFieldData(id, { allowMultipleValue: e.target.checked });
  };

  const addOption = () => {
    const optionsCount = options.length;
    const newOption = { id: uuidv4(), value: `option ${optionsCount + 1}` };
    setOptionsData([...optionsData, newOption]);
    updateFieldData(id, { options: [...options, newOption] });
  };

  const removeOption = (optionId) => {
    const newOptions = options.filter(option => option.id !== optionId);
    setOptionsData(newOptions);
    updateFieldData(id, { options: newOptions });
  };

  const onOptionChange = (optionId, value) => {
    const newOptions = options.map(option => {
      if (option.id === optionId) {
        return { ...option, value };
      }
      return option;
    });
    setOptionsData(newOptions);
    updateFieldData(id, { options: newOptions });
  };

  return (
    <div className={className}>
      <div className="flex flex-col space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Label</label>
            <input
              type="text"
              value={label}
              onChange={onLabelChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Name (ID)</label>
            <input
              type="text"
              value={name}
              onChange={onNameChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
        </div>

        <div className="flex flex-wrap gap-4">
          <div className="flex items-center">
            <input
              id={`required-${id}`}
              type="checkbox"
              checked={isRequired}
              onChange={onIsRequiredChange}
              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            <label htmlFor={`required-${id}`} className="ml-2 block text-sm text-gray-700">
              Required field
            </label>
          </div>
          <div className="flex items-center">
            <input
              id={`multiple-${id}`}
              type="checkbox"
              checked={allowMultipleValue}
              onChange={onAllowMultipleValueChange}
              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            <label htmlFor={`multiple-${id}`} className="ml-2 block text-sm text-gray-700">
              Allow multiple selections
            </label>
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Options</label>
          <div className="space-y-2">
            {optionsData.map((option) => (
              <div key={option.id} className="flex items-center">
                <input
                  type="text"
                  value={option.value}
                  onChange={(e) => onOptionChange(option.id, e.target.value)}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
                <button
                  type="button"
                  onClick={() => removeOption(option.id)}
                  className="ml-2 p-1 text-red-600 hover:text-red-900 focus:outline-none"
                  disabled={options.length <= 1}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-5 w-5">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </button>
              </div>
            ))}
          </div>
          <button
            type="button"
            onClick={addOption}
            className="mt-2 inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            Add Option
          </button>
        </div>
      </div>
    </div>
  );
}

export default SelectField;